const axios = require("axios").default; 

const state = {
  isLoading: false
};

const mutations = {
  SET_LOADING(state, isLoading) {
    this.state.caller.isLoading = isLoading;
  }
}

const actions = {
  async fetchData({
    commit
  }, opt) {
    
    opt.setLoading = (opt.setLoading != undefined ? opt.setLoading : true)

    if (opt.setLoading)
      commit("SET_LOADING", true);

    opt.data = opt.data || {};
    opt.contentType = opt.contentType || "application/json";
    opt.url = `${process.env.VUE_APP_CLOUDCT_API}` + `/${opt.url}`;
    
    return await axios({
        headers: {
          "Content-Type": opt.contentType,
          "cache-control": "no-cache",
          Accept: "*/*"
        },
        method: opt.method,
        data: opt.data,
        url: opt.url
      })
      .then(() => {
        commit("SET_LOADING", false);

      })
      .catch(async function (error) {
        commit("SET_LOADING", false);
        if (error.response == undefined) {
          return
        }        
      });
  },

};
export default {
  state,
  namespaced: true,
  mutations,
  actions
};